export default "__VITE_ASSET__kz3b132___"